import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * The page this route used to be is Get started now: one door for a person
 * new or coming back. A link or a bookmark to the old address lands there,
 * keeping the search it carried (`?redirect=`, a vendor's `?door=`, the
 * emailed code's `?email=&code=`).
 */
export const Route = createFileRoute('/sign-up')({
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/get-started', search: search as Record<string, string | number | undefined>, replace: true });
  },
});
